import { CircleXFilled } from '@/frontend/SVGs/CircleXFilled';
import { I18n } from '@/i18n/I18n';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export function ValidationsFailedIcon(props: { placement?: 'top' | 'right', singleValidation?: boolean }) {
  const { placement } = props;
  // const label = singleValidation ? I18n.get('validationFailed') : I18n.get('validationsFailed');
  const label = I18n.get('validationsNotAvailableInWeb');

  return (
    <OverlayTrigger
      placement={placement || 'top'}
      overlay={<Tooltip>
        {label}
      </Tooltip>}
    >
      <div aria-label={label}>
        <CircleXFilled color="var(--red-600)" />
      </div>
    </OverlayTrigger>
  );
}
